<template>
  <div v-if="show && ready">
    <div class="card">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <h1>Usuários</h1>
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>
            <toggle-button class="mb-0 mr-3"
              v-model="form.status"
              :width="80"
              :height="25"
              :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"/>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <b-form-group class="col-12 col-md-2"
            label="Perfil*"
            label-for="roles">

            <multiselect
              v-model="selectedRole"
              @select="updateForm('role_id', arguments[0])"
              :showLabels="false"
              :allowEmpty="false"
              selectedLabel="Selecionado"
              :limitText="count => `e ${count} mais`"
              :options="roles"
              label="name"
              :required="true"
              placeholder="Selecione o Perfil"
              track-by="id">
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear"
                  v-if="selectedRole"
                  @mousedown.prevent.stop="selectedRole = null">
                  <i class="fa fa-times"></i>
                </div>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group class="col-12 col-md-4"
            label="Nome Completo*"
            label-for="name"
            description="">
            <b-form-input id="name"
              type="text"
              v-model="form.name"
              required
              placeholder="Nome Completo do Usuário"
              :class="{
                'is-invalid': submitted && form.errors.has('name')
              }"></b-form-input>
          </b-form-group>

          <div class="col-12 col-md-6 form-group">
            <label for="email">E-mail <!--<span class="text-muted">(Mesmo e-mail do LDAP)</span>--></label>
            <b-form-input id="email"
              type="text"
              :disabled="!emptyInstance"
              required
              v-model="form.email"
              placeholder="E-mail do Usuário"
              :class="{
                'is-invalid': submitted && form.errors.has('email')
              }"></b-form-input>
          </div>

        <div class="col-12 text-right changePassword" v-show="instance.id">
          <a href="#" @click.prevent.stop="togglePassword">
            <small>{{ updatePassword ? 'Ocultar' : 'Alterar Senha' }}</small>
          </a>
        </div>
        <template v-if="updatePassword">
          <b-form-group class="col-12 col-md-6"
            label="Senha"
            label-for="password"
            :description="instance.id ? 'Apenas preencha os campos de senha se você quiser atualiza-la' : ''">
            <b-form-input id="password"
              type="password"
              v-model="form.password"
              placeholder="******"
              :class="{
                'is-invalid': submitted && form.errors.has('password'),
                'is-valid': submitted && !form.errors.has('password')
              }"></b-form-input>
          </b-form-group>
          <b-form-group class="col-12 col-md-6"
            label="Confirmação da Senha"
            label-for="password_confirmation"
            description="">
            <b-form-input id="password_confirmation"
              type="password"
              v-model="form.password_confirmation"
              placeholder="******"
              :class="{
                'is-invalid': submitted && form.errors.has('password'),
                'is-valid': submitted && !form.errors.has('password')
              }"></b-form-input>
          </b-form-group>
        </template>

        </div>
      </div>
    </div>
    <div v-if="instance.id" class="card">
      <div class="card-header">
        <h1>Dados de acesso</h1>
      </div>
      <div class="card-body">
        <dl class="row mb-0">
          <dt class="col-sm-2">Cadastrado em</dt>
          <dd class="col-sm-10">
            {{ instance.created_at | moment('DD/MM/YYYY HH:MM') }}
          </dd>

          <dt class="col-sm-2">Último acesso</dt>
          <dd class="col-sm-10">
            <span v-if="instance.last_login">
              {{ instance.last_login_formatted }}
            </span>
            <span v-else>
              Nenhum acesso foi registrado
            </span>
          </dd>

          <dt class="col-sm-2">Total de acessos</dt>
          <dd class="col-sm-10">
            {{ instance.days_logged || 'Nenhum acesso foi registrado' }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="card-footer text-right">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { get, set, merge, clone, isArray, isObject } from 'lodash'
import { resolveHTTP } from '@/services/api'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
          roles: [{}],
          avatar: []
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      show: true,
      updatePassword: false,
      locks: {
        categories: true
      },
      empty: {
        status: true,
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '',
        roles: [{}]
      },
      selectedRole: {},
      roles: []
    }
  },

  watch: {
    '$props': {
      handler: function (newProps, oldProps) {
        if (!get(newProps, 'form.role_id', false)) {
          this.selectedRole = null
          this.form.role = ''
        } else {
          if (!this.form.role) {
            set(this.form, 'roles', [get(this.selectedRole, 'id', null)])
            this.form.role = get(this.selectedRole, 'slug', '')
          }
        }
      },
      deep: true
    },

    selectedRole () {
      set(this.form, 'roles', [get(this.selectedRole, 'id', null)])
      this.form.role = get(this.selectedRole, 'slug', '')
    }
  },

  computed: {
    ready () {
      return !this.locks.roles
    },

    ...mapGetters({
      loggedUser: 'auth/user'
    }),

    showDetails () {
      return get(this.selectedRole, 'slug', 'admin') !== 'admin'
    },

    emptyInstance () {
      return get(this.instance, 'id', null) === null
    }
  },

  methods: {
    get,

    ...mapActions({
      fetchUser: 'auth/fetchUser'
    }),

    updateForm (path, value, valuePath) {
      set(this.form, path, isObject(value) ? get(value || {}, valuePath || 'id', null) : value)
    },

    updateReleaseDate (path, { date, oldDate }) {
      set(this.form, path, date ? date.format('YYYY-MM-DD HH:mm:ss') : null)
    },

    togglePassword () {
      this.updatePassword = !this.updatePassword

      if (!this.updatePassword) {
        this.form.password = ''
        this.form.password_confirmation = ''
      }
    }
  },

  created () {
    const self = this

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(merge(self.empty, self.instance))
      self.selectedRole = self.instance.roles.length ? self.instance.roles[0] : {}
    } else {
      self.updatePassword = true
      self.form.withData(clone(self.empty)).setInitialValues(clone(self.empty))
    }

    // Fixes the form for profile
    const profile = get(self.form, 'profile', false)
    if (isArray(profile) || !isObject(profile)) {
      set(self.form, 'profile', {})
    }

    // Fixes the role
    self.form.roles = [get(self.selectedRole, 'id', null)]
    self.form.role_id = get(self.selectedRole, 'id', null)
    self.form.role = get(self.selectedRole, 'slug', null)

    // Lets grab the roles for the form
    resolveHTTP('/system/roles').index({ params: { _onepage: true, '_scope[]': 'onlyOnManager' } })
      .then(function (res) {
        self.roles = res.data.collection
        self.locks.roles = false
        self.selectedRole = self.form.role_id
          ? self.roles.find((o) => o.id === self.form.role_id)
          : null
      })
  }
}
</script>

<style lang="scss" scoped>
  .changePassword {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/System/User.vue